export const PosStorageKey = {
  cart: 'CART',
  productMenu: 'PRODUCT_MENU',
  sideMenu: 'SIDE_MENU',
  auth: 'AUTH',
  bill: 'BILL',
  cashier: 'CASHIER',
  pos: 'POS',
  recommend_product: 'RECOMMEND_PRODUCT',
  permission: 'PERMISSION',
};
